var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldSimcard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.47 3.47A5.003 5.003 0 0 0 12.93 2H8C5 2 3 4 3 7v10c0 3 2 5 5 5h8c3 0 5-2 5-5v-6.93c0-1.33-.53-2.6-1.46-3.53l-3.07-3.07zM10 18.5c-1.65 0-3-1.35-3-3V15a.5.5 0 0 1 .5-.5h3.75c.14 0 .25.11.25.25V18a.5.5 0 0 1-.5.5h-1zm1.25-5H7.5A.5.5 0 0 1 7 13v-.5c0-1.65 1.35-3 3-3h1a.5.5 0 0 1 .5.5v3.25c0 .14-.11.25-.25.25zm2.75 5h-1a.5.5 0 0 1-.5-.5v-3.25c0-.14.11-.25.25-.25h3.75a.5.5 0 0 1 .5.5v.5c0 1.65-1.35 3-3 3zm-1.25-5c-.14 0-.25-.11-.25-.25V10a.5.5 0 0 1 .5-.5h1c1.65 0 3 1.35 3 3v.5a.5.5 0 0 1-.5.5h-3.75z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldSimcard);
export default __webpack_public_path__ + "static/media/vuesax-bold-simcard.5a0cfb9f411c7edc8e1da3b8273a1b1c.svg";
export { ForwardRef as ReactComponent };